var FactoryMultiImages=0;
function MultiImages()
{
    FactoryMultiImages++;
    this.init.apply(this,Array.prototype.slice.call(arguments,0));
    return this;
}

$.extend(MultiImages.prototype,{
    el:null,
    $el:null,
    template:'<div class="multiimages-drop-zone"> <label > <span><i class="zmdi zmdi-upload"></i> '+window.LANGUAGE['multi.upload-drop-files']+'</span> <ul class="images"></ul></label> <input type="file" multiple> </div>',
    content:null,
    input:null,
    images:null,
    fieldName:'images',
    meta:{},
    langs:[],
    currentLang:'',
    init:function(element,fieldName) {
        this.el=element;
        this.$el=$(this.el);
        this.fieldName=fieldName;

        //detect languages
        var langs = [];
        var defLang = "";
        $(".tab-nav [data-language]").each(function(){
            langs.push($(this).attr("data-language"));
            if($(this).hasClass("active")) {
                defLang = $(this).attr("data-language");
            }
        });
        this.langs = langs;
        this.currentLang = defLang.length? defLang: this.langs[0];

        console.log("found langs",this.langs);
        console.log("current lang",this.currentLang);
        this.changeLocale(this.currentLang);
        var self =this;
        $("body").on("click","[data-language]",function() {
            self.changeLocale($(this).attr("data-language"));
        });

        this.content=$(this.template);
        this.images=this.content.find("ul.images");
        this.$el.append(this.content);
        this.$el.find(".images").sortable({
            containerSelector: 'ul',
            itemSelector: 'li',
            handle:'.drag-wrap span'
        });
        this.input=this.content.find("input");
        this.input.attr("id","multiimages_"+FactoryMultiImages);
        this.content.find("label").attr("for","multiimages_"+FactoryMultiImages);

        this.attachDropEvents();
        this.input[0].style.display='none';
        this.grabImages();
    },
    changeLocale:function(slang,$el) {
        if(_.isUndefined($el)) {
            $el = this.$el;
        }
        this.currentLang = slang;
        for(var i in this.langs) {
            var lang = this.langs[i];
            $el.find(".show-lang-"+lang).hide();
        }
        $el.find(".show-lang-"+slang).show();
    },
    grabImages:function()
    {
        var imgs=this.$el.find("img");
        for(var i=0;i<imgs.length;i++)
        {
            var img=$(imgs[i]);
            var rImg=new Image();
            rImg.src=img.attr("src");
            var meta=JSON.parse("{}");
            meta.media_id = img.attr("data-id");
            if(!_.isUndefined(img.attr("data-meta")))
                _.extend(meta,JSON.parse(img.attr("data-meta")));
            console.log(meta);
            this.createCropper(rImg,_.clone(meta));
            img.remove();

        }
    },
    attachDropEvents:function() {
        this.content[0].addEventListener('dragover', this.handleDragOver.bind(this));
        this.content[0].addEventListener('dragleave', this.handleDragLeave.bind(this));
        this.content[0].addEventListener('drop', this.handleDrop.bind(this));
        this.input[0].addEventListener('change', this.handleFileSelect.bind(this));
    },
    handleDragOver: function (e) {
        e.preventDefault();
        if(!this.$el.hasClass("hover-drag"))
            this.$el.addClass("hover-drag");
    },
    handleDragLeave: function (e) {
        e.preventDefault();
        this.$el.removeClass("hover-drag");
    },
    handleDrop:function (e) {
        e.preventDefault();
        this.$el.removeClass("hover-drag");
        this.handleFileItems(e.dataTransfer.items || e.dataTransfer.files);
    },
    handleFileSelect:function(e) {
        this.handleFileItems(e.target.files);
    },
    handleFileItems:function(items) {
        var l = items.length;
        for (var i=0; i<l; i++) {
          this.handleItem(items[i]);
        }
    },
    handleItem:function(item) {

        // get file from item
        var file = item;
        if (item.getAsFile && item.kind =='file') {
            file = item.getAsFile();
        }

        this.handleFile(file);
    },
    handleFile: function(file) {
        this.$el.closest('form').attr('data-dirty','true');
        this.createCropper(file);
    },
    createCropper: function(file, meta,videofile) {
        // create container element for cropper
        var Type=(file && file.type)?file.type.split("/"):"";
        var self = this;

        if(Type[0]==="video") {
            this.grabVideoFrame(file,media_id);
            return;
        }
        var htmlCropper = '<li><div class="row flex-row"><div class="col-sm-1 drag-wrap"><span></span></div><div class="cropper _col-sm-4"></div><div class="col-sm-7">';
        var lmeta = JSON.parse(JSON.stringify({ video: videofile }));
        if(meta) {
            lmeta.media_id = meta.media_id;
            lmeta.action = meta.action? JSON.parse(JSON.stringify(meta.action)):{};
            lmeta.description = meta.description?JSON.parse(JSON.stringify(meta.description)):{};
        }
        var used = [];

        for(var ie  in this.langs) {

            var lang = this.langs[ie];
            if(used.indexOf(lang)!==-1) {
                continue;
            }
            used.push(lang);
            htmlCropper += '<div class="show-lang-'+lang+' text-show-place"> <div class="fg-line m-t-15">' +
                '<textarea data-no-summernote="true" rows="3" class="form-control" data-key="description" data-lang="'+lang+'" placeholder="'+LANGUAGE['intro.description']+'">'+((meta && meta.description && meta.description[lang]) ?  meta.description[lang] : '')+'</textarea>' +
                '</div>' +
                '<div class="fg-line m-t-10"><input class="form-control" data-key="action" data-lang="'+lang+'" value="'+((meta && meta.action && meta.action[lang]) ?  meta.action[lang] : '')+'" placeholder="'+LANGUAGE["intro.url"]+'"/></div></div>';


        }
        htmlCropper += '</div></div></li>';

        var cropper = $(
            htmlCropper
            );
        cropper.on("click",function(e){ e.preventDefault(); return false;});
        cropper.on("click mousedown, mouseup, mousemove",".cropper",function(e){ e.preventDefault(); return false;});

        this.changeLocale(this.currentLang,cropper);

        if(meta && meta.media_id) {
            cropper.attr("data-id", meta.media_id);
            cropper.find("div.cropper").append(file);
        }
        cropper.find("div.cropper").append('<input type="file" name="'+this.fieldName+'[]"  data-grab="images"/>');
        this.images.append(cropper);


        var slimlocal = Slim.create(cropper.find("div.cropper")[0], {
            meta:lmeta,
            "label":LANGUAGE["slim.label"],
            "buttonCancelTitle":LANGUAGE["basic.cancel"],
            "buttonEditTitle":LANGUAGE["slim.button-edit-title"],
            "buttonRemoveTitle":LANGUAGE["slim.button-remove-title"],
            "buttonDownloadTitle":LANGUAGE["slim.button-download-title"],
            "buttonUploadTitle":LANGUAGE["slim.button-upload-title"],
            "buttonConfirmTitle":LANGUAGE["basic.apply"],
            "buttonCancelLabel":LANGUAGE["basic.cancel"],
            "buttonEditLabel":LANGUAGE["slim.button-edit-label"],
            "buttonRemoveLabel":LANGUAGE["slim.button-remove-label"],
            "buttonDownloadLabel":LANGUAGE["slim.button-download-label"],
            "buttonUploadLabel":LANGUAGE["slim.button-upload-label"],
            "buttonConfirmLabel":LANGUAGE["basic.apply"],
            size:{width:2732,height:2732},
            download:true,
         /*   defaultInputName: this.fieldName+'[]',*/
            didInit: function() {
                // load the file to our slim cropper
                if(!meta || !meta.media_id) {
                    this.load(file);

                }else{
                    this._save();
                }
                if(self.images.find("li").length>0 && !self.images.hasClass("active"))
                    self.images.addClass("active")
            },
            didRemove: function() {
                cropper.remove();
                this.destroy();
                if(self.images.find("li").length==0 && self.images.hasClass("active"))
                    self.images.removeClass("active");
                if(meta && meta.media_id) {
                    $("input[name='" + self.fieldName + "[]'][value='" + meta.media_id + "']").remove();
                }
                self.$el.closest('form').attr('data-dirty','true');

                self.images.append($("<input  data-grab=\"images\"/>").attr("type","hidden").attr("name",self.fieldName+"[]").attr("value",JSON.stringify({
                    action:'delete',
                    media_id:meta?meta.media_id:''
                })));
            }
        });

        cropper.find(".text-show-place input, .text-show-place textarea").on("keyup",function(){
            var val = $(this).val();
            var key = $(this).attr("data-key");
            var lang = $(this).attr("data-lang");
            if(!slimlocal.data.meta[key]) {
                slimlocal.data.meta[key] = {};
            }
            slimlocal.data.meta[key][lang] = val;
            slimlocal._save();
            console.log(JSON.stringify(slimlocal.data));
        })

    },
    videos:0,
    grabVideoFrame:function(file,media_id) {
        var self=this;
        var VidId=++self.videos;
        console.log("grab frame - file reader");
            console.log("grab frame - create video tag");

            var video = document.createElement("video");
            video.addEventListener('loadeddata', function() {
                console.log("Loaded the video's data! grab");
                var canvas = document.createElement("CANVAS");
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;

                canvas.getContext('2d').drawImage(video, 0, 0);
                var dataUri = canvas.toDataURL('image/jpeg', 100);
                var data = dataUri.split(',')[1];
                var mimeType = dataUri.split(';')[0].slice(5)

                var bytes = window.atob(data);
                var buf = new ArrayBuffer(bytes.length);
                var arr = new Uint8Array(buf);

                for (var i = 0; i < bytes.length; i++) {
                    arr[i] = bytes.charCodeAt(i);
                }
                video=null;
                canvas=null;

                AddToClosestForm(self.$el,"video_"+(VidId),file);

                var blob = new File([ arr ], "video["+(VidId)+"]",{ type: mimeType });
                self.createCropper(blob,media_id,VidId);
            }, false);

           video.src=URL.createObjectURL(file);
        return file;
    }
});

$(function(){
    $(".multiimages").each(function(i,item){
        if(item.multi)
            return;
            item.multi = new MultiImages(item, $(item).attr("data-field"));
    });
});

function OnSlimUploadSetDirty(f,i) {
    $('form').attr('data-dirty','true');
    return true;
}